<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        Informações da NF
      </p>
    </header>

    <section class="modal-card-body">
      <p class="has-text-centered">
        <b>Emissão: </b
        >{{
          moment
            .utc(purchaseInvoice.invoice.emission)
            .add(preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        }}
      </p>
      <p class="has-text-centered">
        <b>Número - Série: </b>{{ purchaseInvoice.invoice.number }} -
        {{ purchaseInvoice.invoice.series }}
      </p>
      <p class="has-text-centered">
        <b>Total NF:</b>
        {{ purchaseInvoice.merchant._id.payments.currencySymbol }}
        {{ formatMoney(purchaseInvoice.invoice.totalNF) }}
      </p>
      <br />
      <div class="columns">
        <company-info-details
          title="Fornecedor"
          :company-info="purchaseInvoice.invoice.sellerInfo"
        />
        <company-info-details
          title="Comprador"
          :company-info="purchaseInvoice.invoice.buyerInfo"
        />
      </div>

      <h2 class="subtitle">
        Produtos
      </h2>

      <products-table :products="purchaseInvoice.products" />
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import { mapGetters } from "vuex";

import CompanyInfoDetails from "../purchases-invoices-details/CompanyInfo.vue";
import ProductsTable from "../purchases-invoices-details/ProductsTable.vue";

export default {
  components: {
    CompanyInfoDetails,
    ProductsTable
  },

  props: ["purchaseInvoice"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {},

  computed: {
    ...mapGetters(["preferences"])
  },

  mounted() {}
};
</script>
